import React, { createContext, useContext, useState } from 'react';
import useProtobufProtocol from './useProtobufProtocol';

const ProtobufDeviceContext = createContext();

export const useProtobufDeviceContext = () => {
  const context = useContext(ProtobufDeviceContext);
  if (!context) {
    throw new Error('useProtobufDeviceContext must be used within a ProtobufDeviceProvider');
  }
  return context;
};

export const ProtobufDeviceProvider = ({ children }) => {
  const [isConnecting, setIsConnecting] = useState(false);

  // Use the protobuf protocol service
  const {
    connectionState,
    protobufSchema,
    protobufCharacteristics,
    protobufSchemaRoot,
    protobufSchemaProtocol,
    protobufRoot,
    isInitialized,
    connect,
    disconnect,
    service: protobufProtocolService
  } = useProtobufProtocol();

  // Derive device connection state directly from the protobuf connection state
  const deviceConnectionState = connectionState.isConnected ? '✅ Connected' : 
                               connectionState.connectionLost ? '❌ Connection Lost' : 
                               '❌ Not Connected';
  
  const isDeviceConnected = connectionState.isConnected;

  const handleConnect = async () => {
    setIsConnecting(true);
    
    try {
      // Connect to the protobuf service
      await connect();
    } catch (error) {
      console.error('ProtobufDeviceContext: Error connecting to protobuf service:', error);
    } finally {
      setIsConnecting(false);
    }
  };

  const handleDisconnect = () => {
    disconnect();
  };

  const handleConnectionStateChange = (state) => {
    // Handle connection state change
  };

  // Shared state for sent points (used by multiple components)
  const [sentPoints, setSentPoints] = useState([]);

  const value = {
    // Connection state
    deviceConnectionState,
    isConnecting,
    isDeviceConnected,
    
    // Protobuf protocol state
    connectionState,
    protobufSchema,
    protobufCharacteristics,
    protobufSchemaRoot,
    protobufSchemaProtocol,
    protobufRoot,
    isInitialized,
    
    // Connection methods
    handleConnect,
    handleDisconnect,
    handleConnectionStateChange,
    
    // Shared state
    sentPoints,
    setSentPoints,
    
    // Direct service access
    protobufProtocolService
  };

  return (
    <ProtobufDeviceContext.Provider value={value}>
      {children}
    </ProtobufDeviceContext.Provider>
  );
}; 